import { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import SEO from '../components/SEO'

export default function WidgetAdminLogin() {
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError('')
    try {
      const res = await fetch('/api/widget/admin/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password })
      })
      const data = await res.json()
      if (!res.ok) throw new Error(data.error || 'Login failed')
      sessionStorage.setItem('tredex_widget_token', data.token)
      navigate('/admin/widget/clients', { replace: true })
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <SEO title="Widget Platform Login" noIndex />
      <Navbar />
      <div className="dashboard-page">
        <div className="container">
          <div className="profile-card widget-login-card">
            <div style={{ textAlign: 'center', marginBottom: '24px' }}>
              <i className="fas fa-comment-dots" style={{ fontSize: '3rem', color: 'var(--primary)', marginBottom: '12px' }}></i>
              <h1 style={{ fontFamily: 'var(--font-display)' }}>Widget Platform</h1>
              <p style={{ color: 'var(--text-muted)' }}>Sign in to manage AI chat widgets for your clients.</p>
            </div>
            {error && <div className="form-status error" style={{ display: 'block', marginBottom: '16px' }}>{error}</div>}
            <form onSubmit={handleSubmit}>
              <div className="form-group" style={{ marginBottom: '18px' }}>
                <label>Admin Password</label>
                <input
                  type="password"
                  placeholder="Enter your admin password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
              <button type="submit" className="btn btn-primary" style={{ width: '100%', justifyContent: 'center' }} disabled={loading}>
                {loading ? 'Signing in...' : 'Sign In'} <i className="fas fa-arrow-right"></i>
              </button>
            </form>
            <div style={{ textAlign: 'center', marginTop: '16px' }}>
              <Link to="/admin" style={{ color: 'var(--primary)', fontSize: '0.9rem' }}><i className="fas fa-chevron-left"></i> Back to Admin Panel</Link>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}
